<template>
  <div id="popups">
    <div class="topic">
      <div class="title-text">{{ text }}</div>
      <div class="close" @click="onOff"></div>
    </div>
    <slot></slot>
    <div class="options" v-if="isSubmit" :class="{right: !isAnonymous}">
      <div v-if="isAnonymous" class="anonymous" @click="changeAnonymous">
        <div class="check" :class="{active: isAnonymousActive}"></div>
        <div class="text">匿名提问</div>
      </div>
      <div class="submit">
        <div class="cancel" @click="onOff">取消</div>
        <div class="confirm" @click="confirm" v-loading="isSubmitQuestion">
          <div>提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popups',
  props: {
    text: String,
    anonymous: String,
    submit: String,
    isAnonymousActive: {
      type: Boolean,
      default: true
    },
    isSubmitQuestion: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    isAnonymous () {
      if (this.anonymous === 'hide') {
        return false
      } else {
        return true
      }
    },
    isSubmit () {
      if (this.submit === 'hide') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    confirm () {
      if (this.isSubmitQuestion) {
        return
      }
      this.$emit('confirm')
    },
    onOff () {
      if (this.isSubmitQuestion) {
        return
      }
      this.$emit('onOff')
    },
    changeAnonymous () {
      this.$emit('changeAnonymous', !this.isAnonymousActive)
    }
  }
}
</script>

<style scoped>
  .topic {
    display: flex;
    justify-content: space-between;
    height: 19px;
    line-height: 19px;
  }

  .title-text {
    font-size: 22px;
    color: rgba(0, 0, 0, 0.87);
    letter-spacing: 0;
  }

  .close {
    width: 18px;
    height: 18px;
    background: url("../../icons/x-mark.svg") no-repeat center center;
    cursor: pointer;
  }

  .options {
    display: flex;
    justify-content: space-between;
    height: 26px;
    line-height: 26px;
  }

  .right {
    justify-content: flex-end;
  }

  .anonymous {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .check {
    width: 14px;
    height: 14px;
    border-radius: 1px;
    margin-right: 7px;
    background: url("../../icons/anonymous-gray.png");
  }
  .active {
    background: url("../../icons/anonymous-active.svg");
  }

  .text {
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
  }

  .submit {
    display: flex;
    justify-content: space-between;
  }

  .cancel, .confirm {
    box-sizing: border-box;
    width: 68px;
    height: 26px;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    font-size: 14px;
    color: #777777;
    text-align: center;
    line-height: 24px;
    letter-spacing: -0.34px;
    background: #FFFFFF;
    cursor: pointer;
  }

  .confirm {
    margin-left: 9px;
    color: #FFFFFF;
    background: #4A90E2;
  }
</style>



// WEBPACK FOOTER //
// src/components/popups/popups.vue